export default "assets/images/logo-4e05f08a.svg";